module.exports = __webpack_public_path__ + "584b623c6199bc152c2ee4d9faa7ef30.MP3";